var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "excel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.465,
    height: 24.465,
    viewBox: "0 0 24.465 24.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38161",
    "data-name": "Path 38161",
    d: "M17.174,2H9.019A1.019,1.019,0,0,0,8,3.019V7.352L17.174,12.7l4.587,1.936L26.349,12.7V7.352Z",
    transform: "translate(-1.884 -0.471)",
    fill: "#21a366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38162",
    "data-name": "Path 38162",
    d: "M8,9h9.174v5.352H8Z",
    transform: "translate(-1.884 -2.119)",
    fill: "#107c41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38163",
    "data-name": "Path 38163",
    d: "M28.155,2H20V7.352h9.174V3.019A1.019,1.019,0,0,0,28.155,2Z",
    transform: "translate(-4.709 -0.471)",
    fill: "#33c481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38164",
    "data-name": "Path 38164",
    d: "M17.174,16H8v9.684A1.019,1.019,0,0,0,9.019,26.7H25.33a1.019,1.019,0,0,0,1.019-1.019V21.352Z",
    transform: "translate(-1.884 -3.768)",
    fill: "#185c37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38165",
    "data-name": "Path 38165",
    d: "M20,16h9.174v5.352H20Z",
    transform: "translate(-4.709 -3.768)",
    fill: "#107c41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38166",
    "data-name": "Path 38166",
    d: "M14.626,7H8V21.526h6.626a1.022,1.022,0,0,0,1.019-1.019V8.019A1.022,1.022,0,0,0,14.626,7Z",
    transform: "translate(-1.884 -1.648)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38167",
    "data-name": "Path 38167",
    d: "M13.862,8H8V22.526h5.862a1.022,1.022,0,0,0,1.019-1.019V9.019A1.022,1.022,0,0,0,13.862,8Z",
    transform: "translate(-1.884 -1.884)",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38168",
    "data-name": "Path 38168",
    d: "M13.862,8H8V21h5.862a1.022,1.022,0,0,0,1.019-1.019V9.019A1.022,1.022,0,0,0,13.862,8Z",
    transform: "translate(-1.884 -1.884)",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38169",
    "data-name": "Path 38169",
    d: "M13.1,8H8V21h5.1a1.022,1.022,0,0,0,1.019-1.019V9.019A1.022,1.022,0,0,0,13.1,8Z",
    transform: "translate(-1.884 -1.884)",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Back_Plate",
    "data-name": "Back Plate",
    d: "M1.019,8H11.213a1.019,1.019,0,0,1,1.019,1.019V19.213a1.019,1.019,0,0,1-1.019,1.019H1.019A1.019,1.019,0,0,1,0,19.213V9.019A1.019,1.019,0,0,1,1.019,8Z",
    transform: "translate(0 -1.884)",
    fill: "#107c41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38170",
    "data-name": "Path 38170",
    d: "M3.533,18.645l2.474-3.833L3.741,11H5.564L6.8,13.437q.17.346.235.517h.016q.122-.277.256-.538L8.63,11H10.3L7.979,14.791l2.383,3.855H8.581L7.152,15.969a2.234,2.234,0,0,1-.17-.358H6.96a1.687,1.687,0,0,1-.165.346l-1.47,2.687Z",
    transform: "translate(-0.832 -2.59)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38171",
    "data-name": "Path 38171",
    d: "M0,0H24.465V24.465H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.d2a974c2.svg";
export { ForwardRef as ReactComponent };